
export class DataGroup {
  label: string;
  value: string;
  code: string;
  constructor() {
      this.label = "";
      this.value = "";
      this.code = "";
  }
}
